<div *ngIf="highlight;else unicity" class="row  payment-methods">
    <div class="col-md-4 col-sm-4">
        <img [ngClass]="{'selected-payment-method':validateBrandName('mastercard'),'payment-method':!validateBrandName('mastercard')}"
            [src]="imgService.getPaymentBrand('mastercard')" alt="mastercard">
    </div>
    <div class="col-md-4 col-sm-4">
        <img [ngClass]="{'selected-payment-method':validateBrandName('visa'),'payment-method':!validateBrandName('visa')}"
            [src]="imgService.getPaymentBrand('visa')" alt="visa">
    </div>
    <div class="col-md-4 col-sm-4">
        <img [ngClass]="{'selected-payment-method':validateBrandName('maestro'),'payment-method':!validateBrandName('maestro')}"
            [src]="imgService.getPaymentBrand('maestro')" alt="maestro">
    </div>
</div>
<ng-template #unicity>
    <div class="col-md-12">
        <img *ngIf="validateBrandName('mastercard')" class="selected-payment-method unicity"
            [src]="imgService.getPaymentBrand('mastercard')" alt="mastercard">
        <img *ngIf="validateBrandName('visa')" class="selected-payment-method visaUnicity"
            [src]="imgService.getPaymentBrand('visa')" alt="visa">
        <img *ngIf="validateBrandName('maestro')" class="selected-payment-method unicity"
            [src]="imgService.getPaymentBrand('maestro')" alt="maestro">
    </div>
</ng-template>
